export function messageBubbleClasses(role) {
  const base = 'w-fit max-w-[85%] rounded-catering-lg px-3 py-2 text-catering-base shadow-catering-sm'
  return role === 'user'
    ? `${base} ml-auto bg-catering-ink-900 text-catering-cream-100`
    : `${base} mr-auto border border-catering-cream-200 bg-catering-cream-50 text-catering-ink-900`
}

export function latestAssistantMessage(messages) {
  const list = messages || []
  for (let i = list.length - 1; i >= 0; i--) {
    if (list[i].role === 'assistant') return list[i].content || ''
  }
  return ''
}
